
import BaseButton from "@/components/base/BaseButton.vue";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import useAmendment from "@/composables/useAmendment";
import { YYYYMMDD, HHmm } from "@/helpers/dateHelper";
import { AmendmentOptionTypeEnum } from "@/models/enums";
import { CancelBooking, cancelDialogKey } from "@/models/symbols/CancelBooking";
import {
	canceledBookingKey,
	CanceledBooking,
} from "@/models/symbols/CanceledBooking";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { useEventBus } from "@vueuse/core";
import { computed, defineComponent, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	components: {
		BaseSpinner,
		BaseButton,
		BaseSvg,
		BaseCheckbox,
	},
	setup() {
		const bus = useEventBus(cancelDialogKey);
		const show = ref(false);
		const loading = ref<boolean>(false);
		const data = ref<CancelBooking>();
		const canceledBus = useEventBus<CanceledBooking>(canceledBookingKey);
		const { t } = useI18n();
		const { cancelDeparture, cancelBooking } = useAmendment();

		bus.on((e) => {
			show.value = true;
			data.value = e;
		});

		const overlayClicked = (e: any) => {
			e.preventDefault();
			show.value = false;
		};

		const departureToDelete = (route: string) => {
			if (data.value?.cancelRoute) {
				return route === data.value.cancelRoute;
			}

			return true;
		};

		const title = computed(() => {
			switch (data.value?.type) {
				case AmendmentOptionTypeEnum.CancelOutward:
					return t("account.bookings.cancel.outward");
				case AmendmentOptionTypeEnum.CancelReturn:
					return t("account.bookings.cancel.return");
				default:
					return t("account.bookings.cancel.title");
			}
		});

		const submit = async () => {
			v$.value.$touch();
			const isValid = await v$.value.$validate();
			if (!isValid) {
				const firstError = (document as any).querySelector(
					".input-field__error"
				);
				if (firstError) {
					firstError.scrollIntoView({ block: "center", behavior: "smooth" });
				}

				return;
			}

			if (data.value?.booking.bookingReference) {
				
				loading.value = true;

				switch (data.value?.type) {
					case AmendmentOptionTypeEnum.CancelOutward:
					case AmendmentOptionTypeEnum.CancelReturn: {
						if (data.value.cancelRoute) {
							cancelDeparture(
								data.value.cancelRoute,
								data.value.booking.bookingReference
							).finally(() => {
					
								canceledBus.emit({
									bookingReference: data.value?.booking.bookingReference,
								});
								
								loading.value = false;
								show.value = false;
							});
						}

						break;
					}
					case AmendmentOptionTypeEnum.CancelBooking: {
						cancelBooking(data.value.booking.bookingReference)
						.then(() => {
								canceledBus.emit({
										bookingReference: data.value?.booking.bookingReference,
								});
						})
						.finally(() => {
							loading.value = false;
							show.value = false;
						});

						break;
					}
				}
			}
		};

		const state = reactive({
			termsAccepted: false,
		});

		const rules = {
			termsAccepted: {
				v: helpers.withMessage(
					() => "You need to accept the terms & conditions",
					() => state.termsAccepted
				),
			},
		};

		const v$ = useVuelidate(rules, state);

		return {
			show,
			data,
			overlayClicked,
			loading,
			YYYYMMDD,
			HHmm,
			cancelBooking,
			submit,
			departureToDelete,
			AmendmentOptionTypeEnum,
			title,
			v$,
		};
	},
});
